import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { IntegrationConnector, IntegrationConnectorCreate, IntegrationConnectorFilter } from '../data/integrationConnector';

export function createIntegrationConnectorService(client: AxiosInstance) {
  return createCrudService<IntegrationConnector, IntegrationConnectorCreate, IntegrationConnectorFilter>(
    client,
    '/integration/IntegrationConnector',
    'id',
  );
}

export type IntegrationConnectorService = CrudService<IntegrationConnector, IntegrationConnectorCreate, IntegrationConnectorFilter>;
